import axiosInstance from '../services/AxiosInstance';

export function getFeature(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`features?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function deleteFeature(id) {
    return axiosInstance.delete(`features/${id}`);
}

export function createFeature(id) {
    return axiosInstance.post(`features`,id);
}

export function updateFeature(id, data) {
    return axiosInstance.put(`features/${id}`,data);
}
